// extracted by mini-css-extract-plugin
module.exports = {"removeRateIcon":"RemoveCustomRate_removeRateIcon__EdybH"};